import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from './AuthModal';
import './UserMenu.css';

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalMode, setAuthModalMode] = useState<'login' | 'register'>('login');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Открыть модальное окно для входа
  const openLoginModal = () => {
    setAuthModalMode('login');
    setIsAuthModalOpen(true);
  };

  // Открыть модальное окно для регистрации
  const openRegisterModal = () => {
    setAuthModalMode('register');
    setIsAuthModalOpen(true);
  };

  // Закрыть модальное окно
  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  // Переключение выпадающего меню
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Закрыть выпадающее меню
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  // Обработчик выхода из аккаунта
  const handleLogout = () => {
    logout();
    closeDropdown();
  };

  // Если пользователь авторизован, показываем меню пользователя
  if (user) {
    return (
      <div className="user-menu-container">
        <button className="user-button" onClick={toggleDropdown}>
          <span className="user-name">{user.username}</span>
          <div className="avatar">{user.username.charAt(0).toUpperCase()}</div>
        </button>
        
        {isDropdownOpen && (
          <>
            <div className="overlay" onClick={closeDropdown}></div>
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <div className="avatar">{user.username.charAt(0).toUpperCase()}</div>
                <div className="user-info">
                  <div className="username">{user.username}</div>
                  <div className="email">{user.email}</div>
                </div>
              </div>
              
              <div className="dropdown-divider"></div>
              
              <button className="dropdown-item" onClick={handleLogout}>
                Выйти
              </button>
            </div>
          </>
        )}
      </div>
    );
  }

  // Если пользователь не авторизован, показываем кнопки входа и регистрации
  return (
    <div className="auth-buttons">
      <button className="auth-button login" onClick={openLoginModal}>
        Войти
      </button>
      <button className="auth-button register" onClick={openRegisterModal}>
        Регистрация
      </button>
      
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={closeAuthModal}
        initialMode={authModalMode}
      />
    </div>
  );
};

export default UserMenu; 